// 租赁设置
const leaseSetupPreview = [
  {
    el: 'text',
    itemConfig: {
      label: '所属部门',
      prop: 'deptName',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '主订单ID',
      prop: 'entRentOrderId',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '客户类型',
      prop: 'customerType',
      value: '企业客户',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '客户名称',
      prop: 'customerName',
      width: 110,
    },
  },
]
// 绑定车辆
const boundVehiclePreview = [
  ...leaseSetupPreview,
  {
    el: 'text',
    itemConfig: {
      label: '租赁方案',
      prop: 'planName',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '品牌',
      prop: 'brandName',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '车系',
      prop: 'seriesName',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '车型',
      prop: 'modelName',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '租赁类型',
      prop: 'categoryName',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '收款起止日期',
      prop: 'startStopDate',
    },
  },
]
// 全部数据
const allPreview = [
  ...leaseSetupPreview,
  {
    el: 'text',
    itemConfig: {
      label: '租赁方案',
      prop: 'planName',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '品牌',
      prop: 'brandName',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '车系',
      prop: 'seriesName',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '车型',
      prop: 'modelName',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '订车数量',
      prop: 'num',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '租赁类型',
      prop: 'categoryName',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '收款起止日期',
      prop: 'startStopDate',
    },
  },
]
const orderPayPreview = [
  ...leaseSetupPreview,
  {
    el: 'text',
    itemConfig: {
      label: '租赁方案',
      prop: 'planName',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '品牌',
      prop: 'brandName',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '车系',
      prop: 'seriesName',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '车型',
      prop: 'modelName',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '绑定车辆',
      prop: 'plateNo',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '租赁类型',
      prop: 'categoryName',
    },
  },
  {
    el: 'text',
    itemConfig: {
      label: '收款起止日期',
      prop: 'startStopDate',
    },
  },
]
export {
  leaseSetupPreview,
  boundVehiclePreview,
  allPreview,
  orderPayPreview,
}
